import { injectable } from "tsyringe";
import log from "loglevel";
import { EncryptedIdentity, PublicKeyInfo, encryptedIdentity } from "@utilitydelta/nosignup-js";

export const TOKEN_IUserIdentity = Symbol('IUserIdentity');

export interface IUserIdentity {

    /**
     * Signs a challenge string using the private key
     * @param challenge The string to sign
     * @returns Promise resolving to base64 encoded signature
     */
    sign(challenge: string): Promise<string>;

    /**
     * Initializes the identity by either loading or generating key pairs
     */
    publicKey(): Promise<PublicKeyInfo>;

    privateKeyString(): Promise<string>;
}

@injectable()
export class UserIdentity implements IUserIdentity {

    constructor() {
        log.info("Creating UserIdentity");
    }

    private cache: EncryptedIdentity | undefined;

    publicKey = async (): Promise<PublicKeyInfo> => {
        await this.lazyLoad();
        return this.cache!.publicKey();
    }

    privateKeyString = async (): Promise<string> => {
        await this.lazyLoad();
        return this.cache!.privateKeyString();
    }

    sign = async (challenge: string): Promise<string> => {
        await this.lazyLoad();
        log.debug(`Signing challenge '${challenge}' with private key`);
        return await this.cache!.sign(challenge);
    }

    private async lazyLoad() {
        if (this.cache !== undefined) return;

        log.info("Loading using identity")
        this.cache = await encryptedIdentity("ud_publickey", "ud_privatekey");
    }

}